import { Icon } from "./Icon.tsx";

/** "Chart view" toggle icon for PasteDailySeries.tsx's chart/table switch — a single trend line, distinct from ChartIcon.tsx's bar-chart glyph (the top bar's "Results" button) since this view really is a line chart, not bars. */
export function LineChartModeIcon() {
  return (
    <Icon>
      <path d="M4 18l5-6 4 3 7-9" />
    </Icon>
  );
}
